export default __webpack_public_path__ + "static/logo_secondary-68b3149516f4243153a390269c61134c.svg";